import React, {
  useEffect,
  useRef,
} from 'react';

import Map from 'components/Map';
import useConfig from 'hooks/useConfig';
import usePinIconUrl from './usePinIcon';

function MapView({
  merchants,
  center,
  selectedMerchant,
  setSelectedMerchant,
  ...props
}) {
  const merchantMarkersRef = useRef([]);
  const mapRef = useRef();
  const merchantsRef = useRef([]);
  const pinIcon = usePinIconUrl();
  const defaultZoom = useConfig('pwa.defaultMapViewZoom', 12);
  const getIcons = (pinIcon) => (pinIcon && window.google?.maps?.Size ? ({
    defaultIcon: {
      url: pinIcon,
      scaledSize: new window.google.maps.Size(72, 72),
    },
    selectedIcon: {
      url: pinIcon,
      scaledSize: new window.google.maps.Size(144, 144),
    },
  }) : {});
  merchantsRef.current = merchants;

  const redraw = useRef(({
    pinIcon,
  }) => {
    if (!window.google || !mapRef.current || merchantsRef.current.length === 0) {
      return;
    }
    const { defaultIcon } = getIcons(pinIcon);
    merchantMarkersRef.current.forEach((marker) => marker.setMap(null));
    merchantMarkersRef.current = merchantsRef.current.map((merchant) => {
      const marker = new window.google.maps.Marker({
        position: merchant.location,
        map: mapRef.current,
        icon: defaultIcon,
      });
      marker.addListener('click', () => {
        setSelectedMerchant(merchant);
      });
      marker.merchantId = merchant.id;
      return marker;
    });
  });
  useEffect(() => {
    const { defaultIcon, selectedIcon } = getIcons(pinIcon);
    merchantMarkersRef.current.forEach((m) => {
      if (m.merchantId === selectedMerchant?.id) {
        m.setIcon(selectedIcon);
      } else {
        m.setIcon(defaultIcon);
      }
    });
  }, [selectedMerchant, pinIcon]);

  useEffect(() => {
    redraw.current({ pinIcon });
  }, [merchants, pinIcon]);

  function getCenter() {
    if (selectedMerchant?.location) {
      return {
        lat: selectedMerchant.location.lat - 0.001, // to be on center
        lng: selectedMerchant.location.lng,
      };
    }
    return center;
  }

  return (

    <Map
      defaultZoom={defaultZoom}
      center={getCenter()}
      onClick={() => setSelectedMerchant(null)}
      onLoad={(map) => {
        mapRef.current = map;
        redraw.current({ pinIcon });
      }}
      mapContainerStyle={{ borderRadius: 12 }}
      {...props}
    />
  );
}

export default MapView;
